import React from 'react'
import styled from 'styled-components'
import TeamContainer from './TeamContainer'

const team = {
    id: 'theGreats',
    members: [
        {
            description: (
                <>
                    Founded Streamr to make data more available, fair, and valuable for all. Built
                    scalable infrastructure & tools for real-time data for 10 years. Passionate
                    about the decentralization of applications and data infrastructure. Previously
                    CTO at two algorithmic trading companies, one of which he co-founded, and CEO at
                    a startup building cloud-based data infrastructure for IoT.
                </>
            ),
            email: 'henri.pihkala@streamr.com',
            id: 'henriPihkala',
            linkedin: 'https://www.linkedin.com/in/henripihkala',
            name: 'Henri Pihkala',
            role: 'Co-founder, Chief Scientist',
            twitter: 'https://twitter.com/henripihkala',
        },
        {
            description: (
                <>
                    Seasoned executive with a breadth of commercial experience from start-ups to
                    international corporates. Strong team leader with excellent communication
                    skills, sound strategic thinking and a commitment to delivery. Strong track
                    record while developing & maintaining positive team, customer & stakeholder
                    relationships.
                </>
            ),
            id: 'markLittle',
            name: 'Mark Little',
            role: 'CEO',
        },
        {
            description: (
                <>
                    &ldquo;A comfort zone is a beautiful place but nothing ever grows there.&rdquo;
                    ― Unknown Author
                </>
            ),
            id: 'petriSavolainen',
            name: 'Petri Savolainen',
            role: 'CTO',
        },
        {
            description: (
                <>
                    Serial entrepreneur and outside-the-box thinker with several successful exits.
                    Among his successes is Quartal, with Quartal Flife sold to Investis Ltd (UK),
                    Quartal Financial Solutions acquired by KMU Capital AG, and Quartal Content
                    Management bought by Satama Plc.
                </>
            ),
            email: 'nikke.nylund@streamr.com',
            id: 'nikkeNylund',
            linkedin: 'https://www.linkedin.com/in/nikkenylund/',
            name: 'Nikke Nylund',
            role: 'Co-founder',
            twitter: 'https://twitter.com/NikkeNylund',
        },
        {
            description: (
                <>
                    Santeri is a software developer with interests in Distributed systems and Data
                    science. He holds an MSc in computer science with a focus on networking. He
                    joined the team in 2018 with an interest in P2P systems and did his
                    master&apos;s thesis on the Streamr Network&apos;s P2P overlays. Plan B; become
                    a rock star/street musician.
                </>
            ),
            id: 'santeriJuslenius',
            name: 'Santeri Juslenius',
            role: 'Lead Developer',
        },
        {
            description: (
                <>
                    Teo is a full-stack developer and software architect. He has strong work
                    experience since the beginning of the millennium. Previously he has built data
                    analysis solutions e.g. for the finance industry. He prefers simple and
                    straightforward solutions which are easily maintained.
                </>
            ),
            id: 'teoGebhard',
            name: 'Teo Gebhard',
            role: 'Senior Developer',
        },
        {
            description: (
                <>
                    A native from Hanoi, Vietnam, Min has over a decade of experience in design and
                    production of online services and mobile applications. He is currently working
                    as a Design Lead at Helsinki based digital agency, Sangre. His designs are
                    embodied by finding the best balance between the emotional and the rational,
                    between the aesthetic and the functional. He believes unequivocally that a
                    well-minded design will make things better; better for people, better for
                    business and better for our planet.
                </>
            ),
            id: 'minhNguyen',
            name: 'Minh Nguyen',
            role: 'Lead Designer',
        },
        {
            description: (
                <>
                    Mariusz is a passion-driven professional with 10+ years of commercial-grade
                    experience in web application development processes. Scrupulously
                    detail-oriented, dedicated to executing well-crafted&nbsp;UX.
                </>
            ),
            id: 'mariuszRolinski',
            name: 'Mariusz Roliński',
            role: 'Senior Developer',
            website: 'https://www.mariusz.io/',
        },
        {
            description: (
                <>
                    With a background in computer science and technical experience as a developer,
                    Nico brings a strong developer mindset to business development and partnerships
                    at Streamr. Previously, Nico worked in developer relations for Streamr, building
                    bridges between technology and community. Nico works from all over the world and
                    frequently travels to crypto conferences, staying at the forefront of
                    decentralized innovation and industry trends.
                </>
            ),
            id: 'nicoBurkart',
            name: 'Nico Burkart',
            role: 'Business Development & Partnerships',
        },
        {
            description: (
                <>
                    Julieta spent several years in sales and marketing, working for diverse
                    companies in the public sector in Mexico. Before starting with Streamr in 2018,
                    she had a practise as a private language teacher, and was also employed by
                    ARBIS, in the adult education sector in Finland. She studied Spanish Philology
                    at the University of Puebla, Mexico and a programme in Business and
                    Administration in Finland.
                </>
            ),
            id: 'julietaArenasMoran',
            name: 'Julieta Arenas Morán',
            role: 'Office Operations Manager',
        },
        {
            description: (
                <>
                    Tom has worked with various projects across the tech, communication, and Web3
                    sectors. He has managed the Streamr community and all things content and social
                    media since 2018.
                </>
            ),
            email: 'tom.hamilton@streamr.com',
            id: 'tomHamilton',
            linkedin: 'https://www.linkedin.com/in/tommhamilton/',
            name: 'Tom Hamilton',
            role: 'Head of Community and Content',
        },
    ],
}

const UnstyledTeam = ({ className }) => (
    <section className={className} id="team">
        <TeamContainer key={team.id} team={team} />
    </section>
)

const Team = styled(UnstyledTeam)`
    background-color: #f8f8f8;
    color: #13013d;
    overflow-x: hidden;
    padding: 0;
`

export default Team
